import { BaseWidget } from "../widgets";
import { Canvas } from "../components/Canvas";

/**
 * Renders a live report in view-only mode. 
 * 
 * @param {object} props
 * @param {BaseWidget[]} props.widgets Widgets to render. 
 * @returns 
 */
export const Viewer = ({
    // rootNode,
    widgets,
}) => {
    // Match Editor.jsx: skip deleted roots so dual-root reports (e.g. legacy
    // copies that left an empty root behind) still render correctly.
    const rootNode = widgets.find(w => w.parent === null && !w.deleted);

    return (
        <Canvas
            rootNode={rootNode}
            widgets={widgets}
            editable={false}
        />
    );
}